import React from 'react'
import { makeStyles } from '@material-ui/core'
import WifiIcon from '@material-ui/icons/Wifi'
import { DEVICE_TYPE, WIFI_RSSI_LIMITS } from '../../constants'

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center'
    },
    strengthLabel: {
        marginRight: 8
    }
}))

export default function WifiStrengthIndicator({ theme, device, locale }) {
    const classes = useStyles()
    const isTrapsensor = device.device_type === DEVICE_TYPE.trapsensor
    const wifiRssi = isTrapsensor
        ? device.data?.trapsensor?.signal?.percents
        : device.wifi_rssi
    const lastReportType = device.last_report_type
    const wifiRssiLimits = WIFI_RSSI_LIMITS[device.device_type]
    let indicatorColor, strengthLabel

    switch (true) {
        case !wifiRssi ||
            lastReportType === null ||
            lastReportType === '12' ||
            lastReportType === '5' ||
            lastReportType === '4':
            indicatorColor = theme.secondary
            strengthLabel = locale.devices.wifiUnknown
            break
        case wifiRssi <= wifiRssiLimits.excellentSignal.max &&
            wifiRssi > wifiRssiLimits.excellentSignal.min:
            indicatorColor = theme.active
            strengthLabel = locale.devices.wifiExcellent
            break
        case wifiRssi <= wifiRssiLimits.goodSignal.max &&
            wifiRssi > wifiRssiLimits.goodSignal.min:
            indicatorColor = theme.active
            strengthLabel = locale.devices.wifiGood
            break
        case wifiRssi <= wifiRssiLimits.lowSignal.max &&
            wifiRssi > wifiRssiLimits.lowSignal.min:
            indicatorColor = theme.warning
            strengthLabel = locale.devices.wifiLow
            break
        case wifiRssi <= wifiRssiLimits.badSignal.max &&
            wifiRssi > wifiRssiLimits.badSignal.min:
            indicatorColor = theme.error
            strengthLabel = locale.devices.wifiBad
            break
        default:
            indicatorColor = theme.secondary
            strengthLabel = locale.devices.wifiUnknown
    }

    return (
        <div className={classes.root}>
            <div className={classes.strengthLabel}>{strengthLabel}</div>
            <div>
                <WifiIcon
                    style={{
                        color: indicatorColor
                    }}
                />
            </div>
        </div>
    )
}
